// extracted by css-extract-rspack-plugin
export default {"crop-image-container":"CropImageModal-module__crop-image-container--tvw9b","cropImageContainer":"CropImageModal-module__crop-image-container--tvw9b"};